/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _remove from 'lodash/remove';
import _has from 'lodash/has';
import _concat from 'lodash/concat';
import _eq from 'lodash/eq';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';
import _assign from 'lodash/assign';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _isObject from 'lodash/isObject';
import _isArray from 'lodash/isArray';
import _size from 'lodash/size';
import _merge from 'lodash/merge';
import _isEmpty from 'lodash/isEmpty';
import { __awaiter, __generator, __decorate } from 'tslib';
import { toJS, isObservable, observable, computed, action } from 'mobx';
import { persist } from 'mobx-persist';
import { firstValueFrom, Subject } from 'rxjs';
import { BasesOptions, EnumBasesKeys } from './basesOptions';
import { BasesUtils } from './basesUtils';

var BaseModel =
/** @class */
function () {
  function BaseModel(options) {
    this.options = {
      type: 'object'
    };
    /**
     * 持久化初始化完成 Subject
     * @type {Promise<any>}
     * @memberof ControllerUser
     */

    this.HydrateSubject = new Subject();
    /** 数据加载状态 */

    this.loading = false;
    /** 存储空间 */

    this._storage = {};
    /** 源数据 */

    this._value = undefined; // BasesOptions.reactive(this);

    this.onInit(options);
  }

  BaseModel.prototype.onInit = function (options) {
    if (!_isEmpty(options)) {
      _merge(this.options, options);

      switch (this.type) {
        case 'list':
          this.set([]);
          break;

        case 'map':
        case 'object':
          this.set({});
          break;
      }

      this.createHydrate();
    }
  };

  Object.defineProperty(BaseModel.prototype, "type", {
    /** 数据类型 */
    get: function get() {
      return this.options.type;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "storageKey", {
    get: function get() {
      if (this.options.storageKey) {
        return BasesOptions.createStorageKey(this.options.storageKey);
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "HydrateAsync", {
    /**
    * 持久化初始化完成 Promise
    * @type {Promise<any>}
    * @memberof ControllerUser
    */
    get: function get() {
      return firstValueFrom(this.HydrateSubject, {
        defaultValue: this
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "isStorage", {
    /**
     * 有持久化配置
     * @readonly
     * @memberof BaseModel
     */
    get: function get() {
      var options = this.options;
      return !_isEmpty(this.storageKey) || !_isEmpty(options.schema);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "storage", {
    get: function get() {
      if (BasesOptions.observableToJS) {
        return toJS(this._storage);
      }

      return this._storage;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "obsValue", {
    /** 原始的 _value */
    get: function get() {
      return this._value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "value", {
    /** 源数据 */
    get: function get() {
      if (BasesOptions.observableToJS) {
        return toJS(this._value);
      }

      return this._value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseModel.prototype, "size", {
    /** 长度 */
    get: function get() {
      if (this.type !== 'list') {
        throw new Error("value type not Array");
      }

      return _size(this._value);
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 设置 值
   * @param value
   */

  BaseModel.prototype.set = function (value) {
    if (isObservable(value)) {
      value = toJS(value);
    }

    switch (this.type) {
      case 'list':
        if (!_isArray(value)) throw new Error("value type not Array");

      case 'object':
        if (!_isObject(value)) throw new Error("value type not Object");
    } // 无任何更改


    if (_isEqual(this._value, value)) {
      return;
    }

    this._value = value;
    return this;
  };
  /**
   * 获取 值
   * @param value
   */


  BaseModel.prototype.get = function (key, defaultValue) {
    return _get(this._value, key, defaultValue) || defaultValue;
  };
  /**
   * merge 值
   * @param value
   */


  BaseModel.prototype.merge = function (value) {
    if (this.type !== 'object') {
      throw new Error("value type not object");
    }

    if (isObservable(value)) {
      value = toJS(value);
    }

    this._value = _assign({}, toJS(this._value), value);
    return this;
  };
  /**
   * 创建持久化存储
   * @memberof BaseModel
   */


  BaseModel.prototype.createHydrate = function () {
    return __awaiter(this, void 0, void 0, function () {
      var options, _a, storageLoading, Hydrate, schema, error_1;

      var _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            options = this.options;
            _a = options.storageLoading, storageLoading = _a === void 0 ? true : _a;
            _c.label = 1;

          case 1:
            _c.trys.push([1, 3,, 4]);

            Hydrate = BasesOptions.createHydrate(); // 模拟慢 几秒
            // await of(1).pipe(delay(3000)).toPromise()

            if (!this.isStorage) {
              this.HydrateSubject.next(this);
              this.HydrateSubject.complete();
              storageLoading && this.toggleLoading(false);
              return [2
              /*return*/
              ];
            }

            storageLoading && this.toggleLoading(true);
            schema = {};

            if (this.storageKey) {
              _merge(schema, {
                _value: {
                  type: this.type
                },
                _storage: {
                  type: 'object',
                  schema: (_b = {}, _b[EnumBasesKeys.finished] = true, _b[EnumBasesKeys.request] = {
                    type: 'object'
                  }, _b)
                }
              });
            }

            if (!_isEmpty(options.schema)) {
              _merge(schema, {
                _storage: {
                  type: 'object',
                  schema: options.schema
                }
              });
            }

            persist(schema)(this);
            return [4
            /*yield*/
            , Hydrate(this.storageKey, this)];

          case 2:
            _c.sent();

            BasesUtils.warning("\u6301\u4E45\u5316 \u3010 " + this.storageKey + " \u3011", this);
            this.HydrateSubject.next(this);
            this.HydrateSubject.complete(); // lodash.invoke(options, 'onSuccess');

            storageLoading && this.toggleLoading(false);
            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _c.sent();
            this.HydrateSubject.error(error_1);
            this.HydrateSubject.complete();
            storageLoading && this.toggleLoading(false);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 设置一个 值 到存储空间中
   * @param key
   * @param value
   */


  BaseModel.prototype.setStorage = function (key, value) {
    if (_isObject(value) || _isArray(value)) {
      value = _cloneDeep(value);
    }

    var storage = toJS(this._storage);

    _set(storage, key, value);

    this._storage = storage;
    return this;
  };
  /**
   * 获取 存储空间的一个 值
   * @param key
   * @param defaultValue
   */


  BaseModel.prototype.getStorage = function (key, defaultValue) {
    return _cloneDeep(_get(this._storage, key)) || defaultValue;
  };
  /**
   * 清空 存储空间
   * @memberof BaseModel
   */


  BaseModel.prototype.clearStorage = function () {
    // 无任何更改
    if (_isEqual(this._storage, {})) {
      return;
    }

    this._storage = {};
    return this;
  };
  /**
   * 切换 加载状态
   * @param loading
   */


  BaseModel.prototype.toggleLoading = function (loading) {
    if (loading === void 0) {
      loading = !this.loading;
    }

    if (_eq(this.loading, loading)) {
      return this;
    }

    this.loading = loading;
    return this;
  };
  /**
   * 插入数据 type:Array 有效
   * @param {(T | Array<T>)} entitys 数据
   * @param {boolean} [first=false] 是否插入到前面
   * @memberof BaseModel
   */


  BaseModel.prototype.insert = function (entitys, first) {
    if (first === void 0) {
      first = false;
    }

    if (this.type !== 'list') {
      throw new Error("value type not Array");
    }

    entitys = _isArray(entitys) ? entitys : [entitys];
    var value = _isArray(this._value) ? toJS(this._value) : [];

    if (first) {
      value = _concat(entitys, value);
    } else {
      value = _concat(value, entitys);
    }

    return this.set(value);
  };
  /**
   * 修改对象 或者 对象的某个属性 lodash.update
   * @param updater 修改回调函数
   * @param path 修改的值路径
   * @returns
   */


  BaseModel.prototype.update = function (updater, path) {
    if (path) {
      if (_has(this._value, path)) {
        var value = updater(_get(this._value, path));

        _set(this._value, path, value);

        return value;
      }

      throw new Error("value " + path + " undefined");
    }

    return this.set(updater(toJS(this._value)));
  };
  /**
   * 删除数据 type:Array 有效
   * @param {lodash.ListIteratee<unknown>} predicate
   * @memberof BaseModel
   */


  BaseModel.prototype["delete"] = function (predicate) {
    if (this.type !== 'list') {
      throw new Error("value type not Array");
    }

    return _remove(this._value, predicate);
  };

  __decorate([observable], BaseModel.prototype, "loading", void 0);

  __decorate([observable], BaseModel.prototype, "_storage", void 0);

  __decorate([observable], BaseModel.prototype, "_value", void 0);

  __decorate([computed], BaseModel.prototype, "value", null);

  __decorate([computed], BaseModel.prototype, "size", null);

  __decorate([action.bound], BaseModel.prototype, "set", null);

  __decorate([action.bound], BaseModel.prototype, "merge", null);

  __decorate([action.bound], BaseModel.prototype, "setStorage", null);

  __decorate([action.bound], BaseModel.prototype, "clearStorage", null);

  __decorate([action.bound], BaseModel.prototype, "toggleLoading", null);

  __decorate([action.bound], BaseModel.prototype, "insert", null);

  __decorate([action.bound], BaseModel.prototype, "update", null);

  __decorate([action.bound], BaseModel.prototype, "delete", null);

  return BaseModel;
}();

export { BaseModel };
//# sourceMappingURL=baseModel.js.map
